// vm-pagination.js
import { LitElement, html } from 'lit';
import Styles from './vm-profile-image.scss';

export default class VmProfileImage extends LitElement {
    static styles = Styles;

    static properties = {
        userName: { type: String },
        imageSrc: { type: String },
        imageAlt: { type: String },
        link: { type: String },
    };

    constructor() {
        super();
        this.userName = 'Vumedi User';
    }

    render() {
        const name = this.userName || 'Vumedi User';
        return html`
            <figure class="vm-profile-image">
                ${this.imageSrc
                    ? html` <img src="${this.imageSrc}" alt="${this.imageAlt || `${name} profile image`}" /> `
                    : html` <span>${name.slice(0, 1).toUpperCase()}</span> `}
                ${this.link ? html`<a href="${this.link}"></a>` : ''}
            </figure>
        `;
    }
}
